import { Box } from '@/components/Box/Box';
import { ReactNode } from 'react';
import { COLORS } from '@/styles/colors';
import BellIcon from '../images/BellIcon.svg?react';

type StepContentType = {
  children: ReactNode;
};

export const StepContent = ({ children }: StepContentType) => {
  return (
    <Box
      width='100%'
      display='flex'
      flexDirection='row'
      columnGap='10px'
      padding='8px 12px 12px'
      borderRadius='8px'
      background={COLORS.grey[850]}
      alignItems='center'
    >
      <div>
        <BellIcon />
      </div>
      {children}
    </Box>
  );
};
